import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in the real 2026-07 audit event (see metadata.md GROUNDING
// NOTE). Tone: build-in-public. Honest — most flags were false alarms; one bug was
// real; even the first fix was on the wrong path. No hype, no percentages.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.6, caption: "I deep-audited one real thirteen-turn chat about my retrieval pipeline. I'd flagged a handful of bugs — and almost all of them were false alarms." },
];

export const FALSE_ALARMS: ScriptLine[] = [
  { scene: "falseAlarms", fromSec: 0.4, holdSec: 6, caption: "The model it named — grok — I assumed was wrong. It wasn't: that part of the answer was accurate and grounded." },
  { scene: "falseAlarms", fromSec: 6.6, holdSec: 6.3, caption: "A grounding-check \"error\" looked like a failure. It was the check doing its job — correctly flagging a claim the sources didn't support." },
  { scene: "falseAlarms", fromSec: 13.2, holdSec: 4.5, caption: "An \"in_progress\" step that never finished? Just the first half of a normal pair. Nothing was actually broken." },
];

export const REAL_BUG: ScriptLine[] = [
  { scene: "realBug", fromSec: 0.4, holdSec: 6.6, caption: "But one bug was real. Ask about the whole architecture, and the answer leaked internal chunk-map markers straight into the prose." },
  { scene: "realBug", fromSec: 7.2, holdSec: 6.3, caption: "Raw file-index headers, often malformed — plus citations to a \"Knowledge Graph\" that never existed." },
];

export const WRONG_FIX: ScriptLine[] = [
  { scene: "wrongFix", fromSec: 0.4, holdSec: 6.4, caption: "My first fix cleaned up the output. An eight-expert review caught the real problem: I'd patched the wrong code path." },
  { scene: "wrongFix", fromSec: 7.0, holdSec: 5.8, caption: "The leak wasn't in the rendering. It started earlier — where a \"codebase map\" injects raw file-index headers into the prompt." },
];

export const REAL_FIX: ScriptLine[] = [
  { scene: "realFix", fromSec: 0.4, holdSec: 6.6, caption: "The real fix rewrites those headers to a clean \"File: path\" before the model ever sees them." },
  { scene: "realFix", fromSec: 7.2, holdSec: 6.5, caption: "If the model never sees the raw marker, it can't copy it — so the live stream is clean too, not just the saved answer." },
];

export const VERIFIED: ScriptLine[] = [
  { scene: "verified", fromSec: 0.4, holdSec: 6.5, caption: "I re-ran the exact same architecture question on production, and pulled both chats from the database to compare." },
  { scene: "verified", fromSec: 7.2, holdSec: 6, caption: "Four stray markers, nine fake citations, twenty-five broken fragments — all down to zero." },
];

export const LESSONS: ScriptLine[] = [
  { scene: "lessons", fromSec: 0.4, holdSec: 6.5, caption: "Two lessons. First: verify a bug before you fix it. Most of my trace flags were false alarms." },
  { scene: "lessons", fromSec: 7.2, holdSec: 5.5, caption: "Second: trace the actual data path, not the plausible one. The obvious fix was one whole layer too late." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Most \"bugs\" aren't. The real one was hiding one layer upstream of where I first looked." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
